// 法人所定「様式第１号－①（困りごと相談　受付・経過記録書）」の入力項目定義。
// フォーム(HocchokenCasesScreen)とWord出力(hocchokenExport)の両方から参照する
// 唯一の定義元にすることで、項目の追加・改名がずれないようにする。
export const INTAKE_SECTIONS = [
  {
    title: '受付情報',
    fields: [
      { key: 'receptionDate', label: '受付年月日', type: 'date' },
      { key: 'receptionTimeFrom', label: '時間（から）', type: 'time' },
      { key: 'receptionTimeTo', label: '時間（まで）', type: 'time' },
      { key: 'receptionNumber', label: '受付番号', type: 'text', placeholder: '例：R8-1' },
      {
        key: 'receptionMethod', label: '受付形態', type: 'select',
        options: [['phone', '電話'], ['visit', '来所時直接'], ['home_visit', '訪問時'], ['other', 'その他']],
      },
      { key: 'receptionMethodOther', label: '受付形態（その他）', type: 'text' },
      { key: 'recorderName', label: '記入者', type: 'text' },
    ],
  },
  {
    title: '困りごとを持つ人（当事者）',
    fields: [
      { key: 'personFurigana', label: 'フリガナ', type: 'text' },
      { key: 'personName', label: '氏名', type: 'text' },
      { key: 'personPhone', label: '電話番号', type: 'text' },
      { key: 'personPostalCode', label: '郵便番号', type: 'text' },
      { key: 'personAddress', label: '住所', type: 'text' },
      {
        key: 'personBirthEra', label: '生年（元号）', type: 'select',
        options: [['meiji', '明治'], ['taisho', '大正'], ['showa', '昭和']],
      },
      { key: 'personBirthDate', label: '生年月日', type: 'text', placeholder: '例：25年3月1日' },
      { key: 'personAge', label: '年齢', type: 'text' },
      { key: 'personGender', label: '性別', type: 'select', options: [['male', '男'], ['female', '女']] },
      { key: 'careSupportLevel', label: '要支援度', type: 'text' },
      { key: 'careLevel', label: '要介護度', type: 'text' },
      {
        key: 'relationshipType', label: '当事者との関係', type: 'select',
        options: [['self', '本人'], ['spouse', '配偶者'], ['child', '子'], ['family', '他のご家族'], ['acquaintance', '知人'], ['other', 'その他']],
      },
      { key: 'relationshipOther', label: '関係（その他）', type: 'text' },
    ],
  },
  {
    title: '困りごとの申出人（当事者以外の場合）',
    fields: [
      { key: 'reporterFurigana', label: 'フリガナ', type: 'text' },
      { key: 'reporterRelationship', label: '続柄', type: 'text' },
      { key: 'reporterPhone', label: '電話番号', type: 'text' },
      { key: 'reporterName', label: '氏名', type: 'text' },
      { key: 'reporterPostalCode', label: '郵便番号', type: 'text' },
      { key: 'reporterAddress', label: '住所', type: 'text' },
    ],
  },
  {
    title: '困りごとの内容',
    fields: [
      { key: 'issueOccurredDate', label: '事実のあった日', type: 'date' },
      { key: 'issueServiceType', label: '事業の種類', type: 'text' },
      {
        key: 'issueCategory', label: '相談の分類', type: 'select',
        options: [['care_insurance', '介護保険サービスに関わる事項'], ['social_contribution', '社会貢献に関すること（ボランティア等）'], ['other', 'その他']],
      },
      { key: 'issueCategoryOther', label: '分類（その他）', type: 'text' },
      { key: 'issueContent', label: '内容', type: 'textarea' },
      { key: 'reporterRequest', label: '申出人の要望', type: 'textarea' },
    ],
  },
  {
    title: '申出人への確認',
    fields: [
      { key: 'reportToOrgsNeeded', label: '関係機関等への報告', type: 'select', options: [['yes', '要'], ['no', '否']] },
      { key: 'reportToOrgsNote', label: '確認欄', type: 'text' },
      { key: 'attendanceNeeded', label: '話し合いの際の立会い', type: 'select', options: [['yes', '要'], ['no', '否']] },
      { key: 'attendanceNote', label: '確認欄', type: 'text' },
    ],
  },
];

const ALL_FIELDS = INTAKE_SECTIONS.flatMap((s) => s.fields);

const REIWA_START = new Date(2019, 4, 1); // 令和元年5月1日。それより前は西暦のまま扱う。
function eraDateLabel(isoDate) {
  const [y, m, d] = isoDate.split('-').map(Number);
  if (new Date(y, m - 1, d) < REIWA_START) return `${y}年${m}月${d}日`;
  const n = y - 2018;
  return `令和${n === 1 ? '元' : n}年${m}月${d}日`;
}

/** select項目のコード値を表示ラベルに、date項目のISO文字列を和暦表記に変換する（Word出力・表示共通）。 */
export function formatIntakeValue(key, value) {
  if (!value) return '';
  const field = ALL_FIELDS.find((f) => f.key === key);
  if (field?.type === 'select') {
    const opt = field.options.find(([code]) => code === value);
    return opt ? opt[1] : value;
  }
  if (field?.type === 'date') return eraDateLabel(value);
  return value;
}
